export enum ModalName {
  Success = "Success",
  Error = "Error",
  BuyClientNumber = "BuyClientNumber",
  EditClientInfo = "EditClientInfo",
  CreateCoverPage = "CreateCoverPage",
  EditCoverPage = "EditCoverPage",
  DeleteCoverPage = "DeleteCoverPage",
  SearchContact = "SearchContact",
  DeleteFaxFolder = "DeleteFaxFolder",
  CreateFaxRule = "CreateFaxRule",
  DeleteFaxRule = "DeleteFaxRule",
  SelectContact = "SelectContact",
  CreateContact = "CreateContact",
  EditContact = "EditContact",
  DeleteContact = "DeleteContact",
  ExpiredSubscriptionError = "ExpiredSubscriptionError",
  MissingSubscriptionError = "MissingSubscriptionError",
  MissingProfileInfo = "MissingProfileInfo",
  TrialSubscription = "TrialSubscription",
  ChangeSubscription = "ChangeSubscription",
  UnpaidExtraPages = "UnpaidExtraPages",
  DeleteFax = "DeleteFax",
}
